import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../config';

const triggers = hyperdbTriggers({ config,
  triggerName: 'user',
  namespace: 'USERS',
  entryPoint: '/users',
  collectionName: 'users',
  querySearchListing: [
    ['first_name', 'last_name', 'email', ['group', ['name']]],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ first_name: { match: keyword } }, { 'last_name': { match: keyword } }, { 'email': { match: keyword } }] }),
  successMessageCreate: 'User created',
  successMessageUpdate: 'User updated',
  successMessageDelete: 'User deleted',
});

export default triggers;



// WEBPACK FOOTER //
// ./src/frontend/modules/users/triggers.js